import { Icon } from "@iconify/react";
import { useRef, useState } from "react";
import editFill from "@iconify/icons-eva/edit-fill";
import { Link as RouterLink } from "react-router-dom";

import personOutline from "@iconify/icons-eva/person-outline";
import swapOutline from "@iconify/icons-eva/swap-outline";
import moreVerticalFill from "@iconify/icons-eva/more-vertical-fill";
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText, ButtonGroup, Button } from "@mui/material";

export default function MoreMenu({ menus = [], onMoreClick = () => {}, spread = true }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  if (spread) {
    return (
      <ButtonGroup variant="outlined" aria-label="outlined button group">
        {menus.map((menu, i) => {
          const { title, icon } = menu;
          return (
            <Button key={i} onClick={() => handleMenuClick(title)}>
              {title}
            </Button>
          );
        })}
      </ButtonGroup>
    )
  }

  function handleMenuClick(title) {
    setIsOpen(false);

    onMoreClick && onMoreClick(title);
  }

  function renderMenus() {
    return menus.map((menu, i) => {
      const { title, icon } = menu;
      return (
        <MenuItem key={i} sx={{ color: "text.secondary" }} onClick={() => handleMenuClick(title)}>
          {/* <ListItemIcon>
            <Icon icon={icon} width={24} height={24} />
          </ListItemIcon> */}
          <ListItemText primary={title} primaryTypographyProps={{ variant: "body2" }} />
        </MenuItem>
      );
    });
  }

  return (
    <>
      {/* <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton> */}

      <Button ref={ref} variant="text" onClick={() => setIsOpen(true)}>
        更多
      </Button>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: "100%" },
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {renderMenus()}
      </Menu>
    </>
  );
}
